import React, { useState, useMemo } from 'react';
import { QUESTIONS, AT_QUESTIONS, calculateType, calculateAT } from '../data/types';
import './Test.css';

export default function Test({ onComplete }) {
  const allQuestions = useMemo(() => [...QUESTIONS, ...AT_QUESTIONS], []);
  const [current, setCurrent]   = useState(0);
  const [answers, setAnswers]   = useState([]);
  const [selected, setSelected] = useState(null);
  const [exiting, setExiting]   = useState(false);

  const q        = allQuestions[current];
  const total    = allQuestions.length; // 30
  const progress = (current / total) * 100;
  const isAT     = q.dim === 'AT';

  // Progress label
  const phase = current < 25
    ? `${current + 1} / 30`
    : `${current + 1} / 30 — Fast fertig!`;

  const handleChoice = (choice) => {
    if (exiting) return;
    setSelected(choice);
    setExiting(true);

    setTimeout(() => {
      const newAnswers = [...answers, { id: q.id, dim: q.dim, choice }];
      setAnswers(newAnswers);
      setSelected(null);
      setExiting(false);

      if (current + 1 >= total) {
        const mbtiAnswers = newAnswers.filter(a => a.dim !== 'AT');
        const atAnswers   = newAnswers.filter(a => a.dim === 'AT');
        const mbtiType    = calculateType(mbtiAnswers);
        const atType      = calculateAT(atAnswers);
        onComplete(`${mbtiType}-${atType}`); // e.g. "INTJ-T"
      } else {
        setCurrent(c => c + 1);
      }
    }, 340);
  };

  return (
    <div className="test-page">
      <nav className="test-nav">
        <span className="logo-text">
          <span className="logo-ich">ICH</span><span className="logo-type">TYP</span><span className="logo-de">.DE</span>
        </span>
        <div className="test-counter">
          Frage <span>{current + 1}</span> / {total}
        </div>
      </nav>

      <div className="progress-wrap">
        <div className="progress-fill" style={{ width: `${progress}%` }} />
      </div>

      {/* Phase indicator */}
      {isAT && current === 25 && (
        <div className="phase-banner">
          ✦ Letzte 5 Fragen — Dein Identitätsprofil
        </div>
      )}

      <main className="test-main">
        <div className={`q-card ${exiting ? 'exit' : ''}`}>
          <div className="q-label">
            {isAT ? '🧭 Identitätsdimension' : `Frage ${current + 1} von ${total}`}
          </div>
          <h2 className="q-text">{q.text}</h2>
          <div className="choices">
            <button
              className={`choice-btn ${selected === 'a' ? 'selected-a' : ''}`}
              onClick={() => handleChoice('a')}
            >
              <div className="choice-badge">A</div>
              <div className="choice-text">{q.a}</div>
            </button>
            <div className="choice-divider">— oder —</div>
            <button
              className={`choice-btn ${selected === 'b' ? 'selected-b' : ''}`}
              onClick={() => handleChoice('b')}
            >
              <div className="choice-badge">B</div>
              <div className="choice-text">{q.b}</div>
            </button>
          </div>
          <p className="test-hint">
            {isAT
              ? 'Wähle die Aussage die dich am besten beschreibt — auch wenn keine perfekt passt.'
              : 'Dein erster Gedanke ist meist der ehrlichste.'}
          </p>
        </div>
      </main>
    </div>
  );
}
